import { create } from 'zustand';
import type { MapViewport } from '@/types';
import { DEFAULT_VIEWPORT } from '@/config/mapbox';

interface MapState {
  viewport: MapViewport;
  selectedGeofenceId: string | null;
  setViewport: (viewport: MapViewport) => void;
  selectGeofence: (id: string | null) => void;
  flyTo: (lng: number, lat: number, zoom?: number) => void;
}

export const useMapStore = create<MapState>((set) => ({
  viewport: DEFAULT_VIEWPORT,
  selectedGeofenceId: null,
  setViewport: (viewport) => set({ viewport }),
  selectGeofence: (id) => set({ selectedGeofenceId: id }),
  flyTo: (longitude, latitude, zoom = 15) =>
    set({ viewport: { longitude, latitude, zoom } }),
}));
